import MobileDetailCardContents from './MobileDetailCardContents';

export default MobileDetailCardContents;
